require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.map");

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var BigInteger = require('bigi');

var Buffer = require('safe-buffer').Buffer;

var ecurve = require('ecurve');

var curve = ecurve.getCurveByName('secp256k1');

var math = require('./math');

var check = require('./check');

var convert = require('./convert');

var concat = Buffer.concat;
var G = curve.G;
var n = curve.n;
var zero = BigInteger.ZERO;
var MUSIG_TAG = convert.hash(Buffer.from('MuSig coefficient')); // Computes ell = SHA256(pubKeys[0], ..., pubKeys[pubKeys.length-1]) with
// pubKeys serialized in compressed form.

function computeEll(pubKeys) {
  check.checkPubKeyArr(pubKeys);
  return convert.hash(concat(pubKeys));
}

function computeCoefficient(ell, idx) {
  var idxBuf = Buffer.alloc(4);
  idxBuf.writeUInt32LE(idx);
  var data = concat([MUSIG_TAG, MUSIG_TAG, ell, idxBuf]);
  return convert.bufferToInt(convert.hash(data)).mod(n);
}

function pubKeyCombine(pubKeys, pubKeyHash) {
  var ell = pubKeyHash || computeEll(pubKeys);
  var X = null;

  for (var i = 0; i < pubKeys.length; i++) {
    var Xi = convert.pubKeyToPoint(pubKeys[i]);
    var coefficient = computeCoefficient(ell, i);
    var summand = Xi.multiply(coefficient);

    if (X === null) {
      X = summand;
    } else {
      X = X.add(summand);
    }
  }

  return convert.pointToBuffer(X);
}

function nonInteractive(privateKeys, message) {
  if (!privateKeys || !privateKeys.length) {
    throw new Error('privateKeys must be an array with one or more elements');
  } // https://blockstream.com/2018/01/23/musig-key-aggregation-schnorr-signatures/


  var rs = [];
  var Xs = [];
  var R = null;

  var _iterator = _createForOfIteratorHelper(privateKeys),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var privateKey = _step.value;

      var _ri = math.deterministicGetK0(privateKey, message);

      var Ri = G.multiply(_ri);

      var _Xi = G.multiply(privateKey);

      rs.push(_ri);
      Xs.push(_Xi);

      if (R === null) {
        R = Ri;
      } else {
        R = R.add(Ri);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  check.checkPubKeysUnique(Xs);
  var ell = computeEll(Xs.map(convert.pointToBuffer));
  var coefficients = [];
  var X = null;

  for (var i = 0; i < Xs.length; i++) {
    var Xi = Xs[i];
    var coefficient = computeCoefficient(ell, i);
    var summand = Xi.multiply(coefficient);
    coefficients.push(coefficient);

    if (X === null) {
      X = summand;
    } else {
      X = X.add(summand);
    }
  }

  var Rx = convert.intToBuffer(R.affineX);
  var e = math.getE(Rx, X, message);
  var s = zero;

  for (var _i = 0; _i < rs.length; _i++) {
    var ri = math.getK(R, rs[_i]);
    s = s.add(ri.add(e.multiply(coefficients[_i]).multiply(privateKeys[_i])).mod(n));
  }

  return concat([Rx, convert.intToBuffer(s.mod(n))]);
}

function sessionInitialize(sessionId, privateKey, message, pubKeyCombined, ell, idx) {
  check.checkSessionParams(sessionId, privateKey, message, pubKeyCombined, ell);
  var session = {
    sessionId: sessionId,
    message: message,
    pubKeyCombined: pubKeyCombined,
    ell: ell,
    idx: idx
  };
  var coefficient = computeCoefficient(ell, idx);
  session.secretKey = privateKey.multiply(coefficient).mod(n);
  var nonceData = concat([sessionId, message, pubKeyCombined, convert.intToBuffer(privateKey)]);
  session.secretNonce = convert.bufferToInt(convert.hash(nonceData));
  check.checkRange('secretNonce', session.secretNonce);
  var R = G.multiply(session.secretNonce);
  session.nonce = convert.pointToBuffer(R);
  session.commitment = convert.hash(session.nonce);
  return session;
}

function sessionNonceCombine(session, nonces) {
  check.checkNonceArr(nonces);
  var R = convert.pubKeyToPoint(nonces[0]);

  for (var i = 1; i < nonces.length; i++) {
    R = R.add(convert.pubKeyToPoint(nonces[i]));
  }

  if (math.jacobi(R.affineY) !== 1) {
    session.nonceIsNegated = true;
    R = R.negate();
  }

  return convert.pointToBuffer(R);
}

function partialSign(session, message, nonceCombined, pubKeyCombined) {
  var R = convert.pubKeyToPoint(nonceCombined);
  var Rx = convert.intToBuffer(R.affineX);
  var e = math.getE(Rx, convert.pubKeyToPoint(pubKeyCombined), message);
  var sk = session.secretKey;
  var k = session.secretNonce;

  if (session.nonceIsNegated) {
    k = k.negate();
  }

  return sk.multiply(e).mod(n).add(k).mod(n);
}

function partialSigVerify(session, partialSig, nonceCombined, idx, pubKey, nonce) {
  var R = convert.pubKeyToPoint(nonceCombined);
  var Rx = convert.intToBuffer(R.affineX);
  var e = math.getE(Rx, convert.pubKeyToPoint(session.pubKeyCombined), session.message);
  var coefficient = computeCoefficient(session.ell, idx);
  var Ri = convert.pubKeyToPoint(nonce);
  var RP = math.getR(partialSig, e.multiply(coefficient).mod(n), convert.pubKeyToPoint(pubKey));

  if (!session.nonceIsNegated) {
    RP = RP.negate();
  }

  var sum = RP.add(Ri);

  if (!sum.curve.isInfinity(sum)) {
    throw new Error('partial signature verification failed');
  }
}

function partialSigCombine(nonceCombined, partialSigs) {
  var R = convert.pubKeyToPoint(nonceCombined);
  check.checkArray('partialSigs', partialSigs);
  var Rx = convert.intToBuffer(R.affineX);
  var s = partialSigs[0];

  for (var i = 1; i < partialSigs.length; i++) {
    s = s.add(partialSigs[i]).mod(n);
  }

  return concat([Rx, convert.intToBuffer(s)]);
}

module.exports = {
  nonInteractive: nonInteractive,
  computeEll: computeEll,
  pubKeyCombine: pubKeyCombine,
  sessionInitialize: sessionInitialize,
  sessionNonceCombine: sessionNonceCombine,
  partialSign: partialSign,
  partialSigVerify: partialSigVerify,
  partialSigCombine: partialSigCombine
};